import type { UiActionParameters } from '../parameters/ui-action'

import { createEvent, sample } from 'effector'
import { readonly } from 'patronum/readonly'
import { options } from '~/core/flags'

const $enabled = readonly(options.$movieNightEnabled)

type MotnOpenDetailsParams = {
  contentType?: 'MOTN_TV_SHOW' | 'MOTN_VOD'
  name?: string
  serviceName?: string
  accessInfo?: string
}

export const motnOpenDetails = createEvent<MotnOpenDetailsParams>()
export const motnDetailsOpened = createEvent<UiActionParameters>()

export const motnOpenStreamingOptions = createEvent<MotnOpenDetailsParams>()
export const motnStreamingOptionsOpened = createEvent<UiActionParameters>()

export const motnOpenProvider = createEvent<MotnOpenDetailsParams>()
export const motnProviderOpened = createEvent<UiActionParameters>()

sample({
  clock: motnOpenDetails,
  filter: $enabled,
  fn: (params): UiActionParameters => ({
    contentType: params.contentType === 'MOTN_TV_SHOW' ? 'tvshow' : 'vod',
    contentName: params.name ?? '',
    serviceName: '',
    accessInfo: '',
    uiElementType: 'poster',
    uiElementName: 'movie_of_the_night_poster',
  }),
  target: motnDetailsOpened,
})

sample({
  clock: motnOpenStreamingOptions,
  filter: $enabled,
  fn: (params): UiActionParameters => ({
    contentType: params.contentType === 'MOTN_VOD' ? 'vod' : 'tvshow',
    contentName: params.name,
    serviceName: '',
    accessInfo: '',
    uiElementType: 'button',
    uiElementName: 'streaming_options',
  }),
  target: motnStreamingOptionsOpened,
})

sample({
  clock: motnOpenProvider,
  filter: $enabled,
  fn: (params): UiActionParameters => ({
    contentType: params.contentType === 'MOTN_VOD' ? 'vod' : 'tvshow',
    contentName: params.name,
    serviceName: params.serviceName ?? '',
    accessInfo: params.accessInfo ?? '',
    uiElementType: 'button',
    uiElementName: 'provider_button',
  }),
  target: motnProviderOpened,
})
